import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import styled from '@mui/styles/styled';
import { useTranslation } from 'react-i18next';
import { DatePickerWithTimezoneSelection } from '../DatePickerWithTimezoneSelection/DatePickerWithTimezoneSelection';
import { useLocalStorage } from '../../hooks/useLocalStorage';

interface IProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  togglerLabel: string;
  disablePast?: boolean | Dayjs;
  disableFuture?: boolean;
}

const CenterVertically = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(2),
}));

export const TogglableDateFormPartial: FC<IProps> = ({
  value,
  onChange,
  togglerLabel,
  disablePast = false,
  disableFuture = false,
}) => {
  useEffect(() => {
    console.log(`Hello hacker!
If you need to set a different renewal time for retro activation, use following code and refresh the page:
localStorage.setItem("customRetroTime", JSON.stringify({ h: 21, m: 37 }));
`);
  }, []);

  const [customTime] = useLocalStorage('customRetroTime', { h: 0, m: 0 });

  const [scheduleTime, setScheduleTime] = useState(
    value
      ? value
      : disablePast
      ? (typeof disablePast === 'object' ? disablePast : dayjs())
          .add(1, 'day')
          .hour(customTime.h)
          .minute(customTime.m)
          .second(0)
      : disableFuture
      ? dayjs().hour(customTime.h).minute(customTime.m).second(0)
      : dayjs()
  );

  const { t } = useTranslation();

  const handleSetSchedule = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        onChange(scheduleTime);
      } else {
        onChange(null);
      }
    },
    [scheduleTime]
  );

  useEffect(() => {
    if (value) setScheduleTime(value);
  }, [value]);

  const onChangeWrapped = useCallback(
    (value: Dayjs | null) => {
      if (value === null) {
        onChange(value);
      } else {
        onChange(value.hour(customTime.h).minute(customTime.m));
      }
    },
    [customTime]
  );

  return (
    <>
      <Grid item xs={4}>
        <CenterVertically>
          <FormControlLabel
            control={<Checkbox checked={!!value} onChange={handleSetSchedule} />}
            label={togglerLabel}
          />
        </CenterVertically>
      </Grid>

      <Grid item xs={8}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePickerWithTimezoneSelection
            disabled={!value}
            disablePast={disablePast}
            disableFuture={disableFuture}
            date={value}
            setDate={onChangeWrapped}
            label={t('common.formLabel.date')}
          />
        </LocalizationProvider>
      </Grid>
    </>
  );
};
